import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import AnalysisResult from "@/components/AnalysisResult";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ReportDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/reports/${id}`).then((r) => setReport(r.data)).catch(() => setError(true));
  }, [id]);

  if (error)
    return (
      <div className="text-center pt-20">
        <p className="text-gray-500">Report not found.</p>
        <Button onClick={() => navigate("/reports")} className="mt-4 bg-[#0A0A0A]">Back to reports</Button>
      </div>
    );

  if (!report)
    return (
      <div className="flex justify-center pt-20">
        <Loader2 className="w-8 h-8 animate-spin text-klein" />
      </div>
    );

  return (
    <div className="max-w-6xl mx-auto">
      <button
        onClick={() => navigate("/reports")}
        data-testid="back-to-reports"
        className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 mb-6 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Back to reports
      </button>
      <AnalysisResult report={report} />
    </div>
  );
}
